import { EmailCheckIcon } from './EmailCheckIcon';

/**
 * author: Andrew Nenakhov
 * id 04876E3C-0FEA-43D5-9B5C-9CFFC711B180
 * name email-check
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-check.svg
 * tags
 */
export const EmailTickIcon = EmailCheckIcon;
export default EmailTickIcon